/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ArquivoDeMarcaDaguaResponse,
  AtualizarLayoutDto,
  CriarLayoutDto,
  ErroResponse,
  LayoutDocumentoResponse,
  LayoutsDocumentoControllerEnviarMarcaDaguaBody,
  ListaDeLayoutsResponse,
  PreviaDeLayoutDto
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getLayoutsDocumentoControllerEnviarMarcaDaguaUrl = () => {




  return `/v1/layouts-documento/marca-dagua`
}

/**
 * @summary Envia a imagem da marca d'água. PNG ou JPG (RGB), até 1 MB.
 */
export const layoutsDocumentoControllerEnviarMarcaDagua = async (layoutsDocumentoControllerEnviarMarcaDaguaBody: LayoutsDocumentoControllerEnviarMarcaDaguaBody, options?: Parameters<typeof httpClient>[1]): Promise<ArquivoDeMarcaDaguaResponse> => {
    const formData = new FormData();
formData.append(`arquivo`, layoutsDocumentoControllerEnviarMarcaDaguaBody.arquivo);

  return httpClient<ArquivoDeMarcaDaguaResponse>(getLayoutsDocumentoControllerEnviarMarcaDaguaUrl(),
  {
    ...options,
    method: 'POST'
    ,
    body: formData
  }
);}





export const getLayoutsDocumentoControllerEnviarMarcaDaguaMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerEnviarMarcaDagua>>, TError,{data: LayoutsDocumentoControllerEnviarMarcaDaguaBody}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerEnviarMarcaDagua>>, TError,{data: LayoutsDocumentoControllerEnviarMarcaDaguaBody}, TContext> => {

const mutationKey = ['layoutsDocumentoControllerEnviarMarcaDagua'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof layoutsDocumentoControllerEnviarMarcaDagua>>, {data: LayoutsDocumentoControllerEnviarMarcaDaguaBody}> = (props) => {
          const {data} = props ?? {};

          return  layoutsDocumentoControllerEnviarMarcaDagua(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LayoutsDocumentoControllerEnviarMarcaDaguaMutationResult = NonNullable<Awaited<ReturnType<typeof layoutsDocumentoControllerEnviarMarcaDagua>>>
    export type LayoutsDocumentoControllerEnviarMarcaDaguaMutationBody = LayoutsDocumentoControllerEnviarMarcaDaguaBody
    export type LayoutsDocumentoControllerEnviarMarcaDaguaMutationError = ErroResponse

    /**
 * @summary Envia a imagem da marca d'água. PNG ou JPG (RGB), até 1 MB.
 */
export const useLayoutsDocumentoControllerEnviarMarcaDagua = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerEnviarMarcaDagua>>, TError,{data: LayoutsDocumentoControllerEnviarMarcaDaguaBody}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof layoutsDocumentoControllerEnviarMarcaDagua>>,
        TError,
        {data: LayoutsDocumentoControllerEnviarMarcaDaguaBody},
        TContext
      > => {
      return useMutation(getLayoutsDocumentoControllerEnviarMarcaDaguaMutationOptions(options), queryClient);
    }
    export const getLayoutsDocumentoControllerPreviaUrl = () => {




  return `/v1/layouts-documento/previa`
}

/**
 * @summary PDF de amostra no layout informado, com o emissor real da sessão
 */
export const layoutsDocumentoControllerPrevia = async (previaDeLayoutDto: PreviaDeLayoutDto, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getLayoutsDocumentoControllerPreviaUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(previaDeLayoutDto)
  }
);}





export const getLayoutsDocumentoControllerPreviaMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerPrevia>>, TError,{data: PreviaDeLayoutDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerPrevia>>, TError,{data: PreviaDeLayoutDto}, TContext> => {

const mutationKey = ['layoutsDocumentoControllerPrevia'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof layoutsDocumentoControllerPrevia>>, {data: PreviaDeLayoutDto}> = (props) => {
          const {data} = props ?? {};

          return  layoutsDocumentoControllerPrevia(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LayoutsDocumentoControllerPreviaMutationResult = NonNullable<Awaited<ReturnType<typeof layoutsDocumentoControllerPrevia>>>
    export type LayoutsDocumentoControllerPreviaMutationBody = PreviaDeLayoutDto
    export type LayoutsDocumentoControllerPreviaMutationError = unknown

    /**
 * @summary PDF de amostra no layout informado, com o emissor real da sessão
 */
export const useLayoutsDocumentoControllerPrevia = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerPrevia>>, TError,{data: PreviaDeLayoutDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof layoutsDocumentoControllerPrevia>>,
        TError,
        {data: PreviaDeLayoutDto},
        TContext
      > => {
      return useMutation(getLayoutsDocumentoControllerPreviaMutationOptions(options), queryClient);
    }
    export const getLayoutsDocumentoControllerDesativarUrl = () => {




  return `/v1/layouts-documento/ativo`
}

/**
 * @summary Desativa o layout em uso — os PDFs voltam ao padrão do sistema
 */
export const layoutsDocumentoControllerDesativar = async ( options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getLayoutsDocumentoControllerDesativarUrl(),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getLayoutsDocumentoControllerDesativarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerDesativar>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerDesativar>>, TError,void, TContext> => {

const mutationKey = ['layoutsDocumentoControllerDesativar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof layoutsDocumentoControllerDesativar>>, void> = () => {


          return  layoutsDocumentoControllerDesativar(requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LayoutsDocumentoControllerDesativarMutationResult = NonNullable<Awaited<ReturnType<typeof layoutsDocumentoControllerDesativar>>>

    export type LayoutsDocumentoControllerDesativarMutationError = unknown

    /**
 * @summary Desativa o layout em uso — os PDFs voltam ao padrão do sistema
 */
export const useLayoutsDocumentoControllerDesativar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerDesativar>>, TError,void, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof layoutsDocumentoControllerDesativar>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getLayoutsDocumentoControllerDesativarMutationOptions(options), queryClient);
    }
    export const getLayoutsDocumentoControllerListarUrl = () => {




  return `/v1/layouts-documento`
}

/**
 * @summary Layouts DO VETERINÁRIO da sessão. Lista vazia é estado válido: usa-se o padrão.
 */
export const layoutsDocumentoControllerListar = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeLayoutsResponse> => {

  return httpClient<ListaDeLayoutsResponse>(getLayoutsDocumentoControllerListarUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getLayoutsDocumentoControllerListarQueryKey = () => {
    return [
    `/v1/layouts-documento`
    ] as const;
    }


export const getLayoutsDocumentoControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLayoutsDocumentoControllerListarQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>> = ({ signal }) => layoutsDocumentoControllerListar({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type LayoutsDocumentoControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>>
export type LayoutsDocumentoControllerListarQueryError = unknown


export function useLayoutsDocumentoControllerListar<TData = Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>,
          TError,
          Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLayoutsDocumentoControllerListar<TData = Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>,
          TError,
          Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useLayoutsDocumentoControllerListar<TData = Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Layouts DO VETERINÁRIO da sessão. Lista vazia é estado válido: usa-se o padrão.
 */

export function useLayoutsDocumentoControllerListar<TData = Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getLayoutsDocumentoControllerListarQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getLayoutsDocumentoControllerCriarUrl = () => {




  return `/v1/layouts-documento`
}

/**
 * @summary Cria um layout. O PRIMEIRO do veterinário já nasce ativo.
 */
export const layoutsDocumentoControllerCriar = async (criarLayoutDto: CriarLayoutDto, options?: Parameters<typeof httpClient>[1]): Promise<LayoutDocumentoResponse> => {

  return httpClient<LayoutDocumentoResponse>(getLayoutsDocumentoControllerCriarUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(criarLayoutDto)
  }
);}





export const getLayoutsDocumentoControllerCriarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerCriar>>, TError,{data: CriarLayoutDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerCriar>>, TError,{data: CriarLayoutDto}, TContext> => {

const mutationKey = ['layoutsDocumentoControllerCriar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof layoutsDocumentoControllerCriar>>, {data: CriarLayoutDto}> = (props) => {
          const {data} = props ?? {};

          return  layoutsDocumentoControllerCriar(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LayoutsDocumentoControllerCriarMutationResult = NonNullable<Awaited<ReturnType<typeof layoutsDocumentoControllerCriar>>>
    export type LayoutsDocumentoControllerCriarMutationBody = CriarLayoutDto
    export type LayoutsDocumentoControllerCriarMutationError = ErroResponse

    /**
 * @summary Cria um layout. O PRIMEIRO do veterinário já nasce ativo.
 */
export const useLayoutsDocumentoControllerCriar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerCriar>>, TError,{data: CriarLayoutDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof layoutsDocumentoControllerCriar>>,
        TError,
        {data: CriarLayoutDto},
        TContext
      > => {
      return useMutation(getLayoutsDocumentoControllerCriarMutationOptions(options), queryClient);
    }
    export const getLayoutsDocumentoControllerAtualizarUrl = (layoutId: string,) => {




  return `/v1/layouts-documento/${layoutId}`
}

/**
 * @summary Edita um layout próprio
 */
export const layoutsDocumentoControllerAtualizar = async (layoutId: string,
    atualizarLayoutDto: AtualizarLayoutDto, options?: Parameters<typeof httpClient>[1]): Promise<LayoutDocumentoResponse> => {

  return httpClient<LayoutDocumentoResponse>(getLayoutsDocumentoControllerAtualizarUrl(layoutId),
  {
    ...options,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(atualizarLayoutDto)
  }
);}





export const getLayoutsDocumentoControllerAtualizarMutationOptions = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerAtualizar>>, TError,{layoutId: string;data: AtualizarLayoutDto}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerAtualizar>>, TError,{layoutId: string;data: AtualizarLayoutDto}, TContext> => {

const mutationKey = ['layoutsDocumentoControllerAtualizar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof layoutsDocumentoControllerAtualizar>>, {layoutId: string;data: AtualizarLayoutDto}> = (props) => {
          const {layoutId,data} = props ?? {};

          return  layoutsDocumentoControllerAtualizar(layoutId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LayoutsDocumentoControllerAtualizarMutationResult = NonNullable<Awaited<ReturnType<typeof layoutsDocumentoControllerAtualizar>>>
    export type LayoutsDocumentoControllerAtualizarMutationBody = AtualizarLayoutDto
    export type LayoutsDocumentoControllerAtualizarMutationError = ErroResponse

    /**
 * @summary Edita um layout próprio
 */
export const useLayoutsDocumentoControllerAtualizar = <TError = ErroResponse,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerAtualizar>>, TError,{layoutId: string;data: AtualizarLayoutDto}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof layoutsDocumentoControllerAtualizar>>,
        TError,
        {layoutId: string;data: AtualizarLayoutDto},
        TContext
      > => {
      return useMutation(getLayoutsDocumentoControllerAtualizarMutationOptions(options), queryClient);
    }
    export const getLayoutsDocumentoControllerExcluirUrl = (layoutId: string,) => {




  return `/v1/layouts-documento/${layoutId}`
}

/**
 * @summary Exclui o layout. Se era o ativo, o padrão do sistema volta a valer.
 */
export const layoutsDocumentoControllerExcluir = async (layoutId: string, options?: Parameters<typeof httpClient>[1]): Promise<void> => {

  return httpClient<void>(getLayoutsDocumentoControllerExcluirUrl(layoutId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getLayoutsDocumentoControllerExcluirMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerExcluir>>, TError,{layoutId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerExcluir>>, TError,{layoutId: string}, TContext> => {

const mutationKey = ['layoutsDocumentoControllerExcluir'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof layoutsDocumentoControllerExcluir>>, {layoutId: string}> = (props) => {
          const {layoutId} = props ?? {};

          return  layoutsDocumentoControllerExcluir(layoutId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LayoutsDocumentoControllerExcluirMutationResult = NonNullable<Awaited<ReturnType<typeof layoutsDocumentoControllerExcluir>>>

    export type LayoutsDocumentoControllerExcluirMutationError = unknown

    /**
 * @summary Exclui o layout. Se era o ativo, o padrão do sistema volta a valer.
 */
export const useLayoutsDocumentoControllerExcluir = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerExcluir>>, TError,{layoutId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof layoutsDocumentoControllerExcluir>>,
        TError,
        {layoutId: string},
        TContext
      > => {
      return useMutation(getLayoutsDocumentoControllerExcluirMutationOptions(options), queryClient);
    }
    export const getLayoutsDocumentoControllerAtivarUrl = (layoutId: string,) => {




  return `/v1/layouts-documento/${layoutId}/ativar`
}

/**
 * @summary Passa a gerar os PDFs com este layout. O anterior deixa de ser o ativo.
 */
export const layoutsDocumentoControllerAtivar = async (layoutId: string, options?: Parameters<typeof httpClient>[1]): Promise<ListaDeLayoutsResponse> => {

  return httpClient<ListaDeLayoutsResponse>(getLayoutsDocumentoControllerAtivarUrl(layoutId),
  {
    ...options,
    method: 'POST'


  }
);}





export const getLayoutsDocumentoControllerAtivarMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerAtivar>>, TError,{layoutId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
): UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerAtivar>>, TError,{layoutId: string}, TContext> => {

const mutationKey = ['layoutsDocumentoControllerAtivar'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof layoutsDocumentoControllerAtivar>>, {layoutId: string}> = (props) => {
          const {layoutId} = props ?? {};

          return  layoutsDocumentoControllerAtivar(layoutId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type LayoutsDocumentoControllerAtivarMutationResult = NonNullable<Awaited<ReturnType<typeof layoutsDocumentoControllerAtivar>>>

    export type LayoutsDocumentoControllerAtivarMutationError = unknown

    /**
 * @summary Passa a gerar os PDFs com este layout. O anterior deixa de ser o ativo.
 */
export const useLayoutsDocumentoControllerAtivar = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof layoutsDocumentoControllerAtivar>>, TError,{layoutId: string}, TContext>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof layoutsDocumentoControllerAtivar>>,
        TError,
        {layoutId: string},
        TContext
      > => {
      return useMutation(getLayoutsDocumentoControllerAtivarMutationOptions(options), queryClient);
    }
